import PropTypes from 'prop-types';
import React from 'react';

import useTranslation from '../../hooks/use_translation';
import Badge from '../framework/badges/badge';

const BookingBadge = ({ dropIn = false, size = 'sm', status }) => {
	const { t } = useTranslation('component_location_booking_badge');

	return (
		<div>
			{status === 'archive' && (
				<Badge label={t('t3')} size={size} variant="danger" />
			)}

			{status !== 'archive' && dropIn && (
				<Badge label={t('t1')} size={size} variant="primary" />
			)}

			{status !== 'archive' && !dropIn && (
				<Badge label={t('t2')} size={size} variant="booking" />
			)}
		</div>
	);
};

BookingBadge.propTypes = {
	dropIn: PropTypes.bool,
	size: PropTypes.string,
	status: PropTypes.string,
};

export default BookingBadge;
